<div class="w-100 d-flex align-items-center justify-content-center">
	<div
		class="card m-0 d-inline-flex shadow-lg text-center text-tertiary px-3 py-2 {{
			aditionalClasses
		}}">
		{{ texto }}
	</div>
</div>
